import {AppSettings} from '../constants';

const IzendaIntegrate = {
  DoIzendaConfig() {
    window.IzendaSynergy.config({
      'WebApiUrl': AppSettings.REPORT_API_URL,
      'BaseUrl': '/',
      'RootPath': '/thirdParty/izenda',
      'CssFile': 'izenda-ui.css',
      'Routes': {
        'ReportDesigner': 'report-reportdesigner',
        'Report': 'report-report',
        'ReportViewer': 'report-reportviewer',
        'ReportViewerPopup': 'report-reportviewerpopup',
        'Viewer': 'report-viewer',
        'Dashboard': 'report-dashboard',
        'New': 'report-dashboard/new',
        'Settings': 'report-settings',
        'Account': 'account',
        'MyProfile': 'myprofile'
      },
      'Timeout': 3600,
      'NeedToEncodeUrl': false,
      'OnReceiveUnauthorizedResponse': this.redirectToLoginPage
    });

  },
  redirectToLoginPage() {
    if (process.env.NODE_ENV === 'development') {
      console.log('Current user is unauthorized to access Izenda function. Navaigate to login page');
    }
    window.location.href = '/sign-in';
  },

  setContext() {
    const currentUserContext = {
      token: localStorage.getItem('izendaToken')
    };
    window.window.IzendaSynergy.setCurrentUserContext(currentUserContext);
  },
  /* Izenda Function */

  RenderIzenda()
  {
    this.setContext();
    let dom = document.getElementById('izenda-root');
    window.IzendaSynergy.render(dom);
    return dom;
  },

  RenderIzendaSettings(callback)
  {
    this.setContext();
    let dom = document.getElementById('izenda-root-settings');
    window.IzendaSynergy.renderSettingPage(dom);
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 500);

    return dom;
  },

  RenderReportList(callback)
  {
    this.setContext();
    let dom = document.getElementById('izenda-root-report-list');
    window.IzendaSynergy.renderReportPage(dom);
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 500);
    return dom;
  },

  RenderReportDesigner(callback)
  {
    this.setContext();
    let dom = document.getElementById('izenda-root-report-designer');
    window.IzendaSynergy.renderReportDesignerPage(dom);
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 500);
    return dom;
  },
  RenderReportViewer()
  {
    this.setContext();
    let dom = document.getElementById('izenda-root');
    window.IzendaSynergy.renderReportViewerPage(dom, '[your report id]');
    return dom;
  },

  RenderReportCustomizedFilterViewer()
  {
    this.setContext();
    let filtersObj = {
      'filters': [],
      'overridingFilterValue':
                               { // filter object to pass to api
                                 p1value: 50, // override filter value at position 1 which is applying on current report, change >30 to >50
                                 p2value: '30;#40' // override filter value at position 2 which is applying on current report, change beetween (20:50) to (30:40)
                               }
    };

    let dom = document.getElementById('izenda-root');
    window.IzendaSynergy.renderReportViewerPage(dom, '[your report id]', filtersObj);
    return dom;
  },

  RenderReportParts()
  {
    //debugger;
    this.setContext();
    window.IzendaSynergy.renderReportPart(document.getElementById('izenda-report-part1'), {
      'id': '[your 1st report part id]'
    });

    window.IzendaSynergy.renderReportPart(document.getElementById('izenda-report-part2'), {
      'id': '[your 2nd report part id]'
    });

    window.IzendaSynergy.renderReportPart(document.getElementById('izenda-report-part3'), {
      'id': '[your 3rd report part id]'
    });

  },

  UpdateResultReportPart(reportPartId, overridingFilterValue, containerId)
  {
    this.setContext();
    window.IzendaSynergy.renderReportPart(document.getElementById(containerId), {
      'id': reportPartId,
      'overridingFilterValue': overridingFilterValue
    });
  },

  RenderSingleReportPart(reportPartId, containerId)
  {
    this.setContext();
    window.IzendaSynergy.renderReportPart(document.getElementById(containerId), {
      'id': reportPartId
    });
  },

  RenderDashboard(callback)
  {
    this.setContext();
    let dom = document.getElementById('izenda-root-dashboard');
    window.IzendaSynergy.renderDashboardPage(dom);
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 500);
    return dom;
  },

  RenderDashboardDesigner(callback)
  {
    this.setContext();
    let dom = document.getElementById('izenda-root-dashboard-designer');
    window.IzendaSynergy.renderNewDashboardPage(dom);
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 500);
    return dom;
  },

  RenderDashboardViewer()
  {
    this.setContext();
    let dom = document.getElementById('izenda-root');
    window.IzendaSynergy.renderDashboardViewerPage(dom, '[your dashboard id]');
    return dom;
  },

  DestroyDom(dom)
  {
    this.setContext();
    window.IzendaSynergy.unmountComponent(dom);
  },

  /* Izenda Helper Function */

  AutoHideIzenaProgressBar() {
    this.HideIzenaProgressBar('izenda-root', 'progressLoader');
  },

  HideIzenaProgressBar(targetId, progressBarId) {
    // select the target node
    var target = document.getElementById(targetId);

    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        let progressBar = document.getElementById(progressBarId);
        if (progressBar) {
          progressBar.style.display = 'none';
        }
      });
    });

    // configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true };
    if (target) {
      // pass in the target node, as well as the observer options
      observer.observe(target, config);
    }
  }
};

export default IzendaIntegrate;



// WEBPACK FOOTER //
// ./src/helper/IzendaIntegrate.js